import { useQuery } from '@tanstack/react-query';
import { broker } from '../services/broker';

export const useBrokerConfig = () => {
  return useQuery({
    queryKey: ['broker-config'],
    queryFn: broker,
  });
};

export default useBrokerConfig;
